var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',[_c('V-container',{staticClass:"piedss"},[_c('h3',{attrs:{"align":"center"}},[_vm._v(" "+_vm._s(_vm.$t("Desktop.ReturnToDesktop.return_to_desktop", _vm.language))+" ")])])],1),_c('div',{staticClass:"d-flex justify-space-around align-center flex-column flex-sm-row"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }